export default {
      id: "check-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#check",
      toString: function () {
        return this.url;
      }
    }